const XHRFactory = {
  config: {
    withCredentials: false,
    customHeaders: [{ header: null, value: null }],
  },

  createXMLHttpRequest: function () {
    const xhr = new XMLHttpRequest();

    if (this.config.customHeaders && Array.isArray(this.config.customHeaders) && this.config.customHeaders.length > 0) {
      const baseOpen = xhr.open.bind(xhr);
      const customHeaders = this.config.customHeaders;
      xhr.open = function (method: string, url: string | URL, async?: boolean, username?: string | null, password?: string | null) {
        baseOpen(method, url, async as boolean, username, password);
        customHeaders.forEach(function (customHeader) {
          if (!!customHeader.header && !!customHeader.value) {
            xhr.setRequestHeader(customHeader.header, customHeader.value);
          }
        });
      };
    }

    return xhr;
  },
};

export { XHRFactory };
